module.exports = __webpack_public_path__ + "img/l1.b417b8e4.png";